<svg class="esf-icon esf-empty-state__icon" width="32" height="32">
  <use [attr.xlink:href]="emptyStateIcon"></use>
</svg>
<div class="esf-empty-state__message">
  <p class="esf-paragraph">
    <small>{{ emptyStateText }}</small>
  </p>
</div>
<button class="esf-button esf-button--standard esf-button--filled esf-button--small" (click)="actionButtonClick()" *ngIf="emptyStateButtonText">
  <svg class="esf-icon esf-button__icon" width="16" height="16">
    <use xlink:href="#esf-icon-plus"></use>
  </svg>
  <span class="esf-button__icon-text">{{ emptyStateButtonText }}</span>
</button>
